import { RevenueStream } from '@interfaces/RevenueStream.interface';
import BaseApiClient from '../BaseApiClient';

export class ApiRevenueStream extends BaseApiClient {
  /**
   * Lists revenue streams
   */
  async list(): Promise<Array<RevenueStream>> {
    return new Promise((resolve, reject) => {
      this.client
        .getList('/revenue-stream')
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch((err) => reject(err));
    });
  }
}

export { revenueStreamQueryKeys } from './query-keys';
export { useRevenueStreamsQuery } from './use-revenue-stream-queries';
